import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorResponse } from '@app/core/models/error-response';
import { AlertService } from '@app/core/services/alert/alert.service';
import { LoginService } from '@app/core/services/login/login.service';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorInterceptor implements HttpInterceptor {
  private readonly injector = inject(Injector);
  private readonly alertService = inject(AlertService);
  private readonly router = inject(Router);


  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError(err => {
        const loginService = this.injector.get(LoginService);
        const wasLoggedIn = !!loginService.userValue;

        if (err.status === 0) {
          loginService.clearCache();
        }

        
        const errorBody: ErrorResponse = !err.error ? new ErrorResponse(err.status) : err.error;
        if ([401, 403, 0].includes(err.status) && wasLoggedIn) {
          this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } });
        }
        if (errorBody?.messages) {
          errorBody.messages.forEach(errorMessage => {
            this.alertService.error(errorMessage);
          });
        }
        const customError = {
          ...err,
          errorBody,
          errorMessages: errorBody?.messages,
        };
        return throwError(() => customError);
      })
    );
  }
}
